import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-bulk-schedule',
  templateUrl: './flight-bulk-schedule.component.html',
  styleUrls: ['./flight-bulk-schedule.component.sass']
})
export class FlightBulkScheduleComponent implements OnInit {

  constructor() { }

  async ngOnInit() {
  }

}
